import { render, staticRenderFns } from "./EstimatesEmpty.vue?vue&type=template&id=5bc1fac4&"
import script from "./EstimatesEmpty.vue?vue&type=script&lang=js&"
export * from "./EstimatesEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports